import * as S from './styles'

const Footer = () => {
  return (
    <S.Footer>
      <div className="container">
        <S.Links>
          <li>
            <a href="#">Termos</a>
          </li>
          <li>
            <a href="#">Contatos</a>
          </li>
          <li>
            <a href="#">Sobre</a>
          </li>
        </S.Links>
        <S.Copyright>
          <p>&copy; Copyright 2024. Todos os direitos reservados</p>
          <img
            src="https://imovelguide.com.br/images/logo-imovel-guide.png"
            alt="Logo"
          />
        </S.Copyright>
      </div>
    </S.Footer>
  )
}

export default Footer
